// 设置根节点html的字体大小用于移动端适配使用
import BigNumber from "bignumber.js";
import dayjs from "dayjs";
export const setupFontSize = () => {
    console.count("setupFontSize");
    (function (doc, win) {
        let resizeEvt = "orientationchange" in win ? "orientationchange" : "resize",
            recalc = function () {
                let htmlDom = doc.getElementsByTagName("html")[0];
                requestAnimationFrame(() => {
                    let clientWidth = doc.documentElement.clientWidth || doc.body.clientWidth;
                    if (!clientWidth) return;
                    htmlDom.style.fontSize =
                        clientWidth >= 578.88 ? "144px" : 154.5 * (clientWidth / 578.88) + "px";
                });
            };
        if (!doc.addEventListener) return;
        win.addEventListener(resizeEvt, recalc, false);
        doc.addEventListener("DOMContentLoaded", recalc, false);
        recalc();
    })(document, window);
};

// 密码正则 6到12位（字母，数字，下划线，减号）
export const pwdRegex = (pwd = "") => {
    let regex = /^[a-zA-Z0-9_-]{6,12}$/;
    return regex.test(pwd);
};

export const phoneRegex = (pwd = "") => {
    let regex = /^1[3-9]\d{9}$/;
    return regex.test(pwd);
};

/**
 * @description 是否是合格http外链
 */
export const isHttpUrl = (url: string) => {
    const regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
    return regex.test(url);
};
export const isHttpsUrl = (url: string) => {
    const regex = /^(?:https?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
    return regex.test(url);
};
/**
 * @description 是否是合格邮箱
 */

export const emailReg = /^\w+(-+.\w+)*@\w+(-.\w+)*.\w+(-.\w+)*$/;
export const isEmail = (email: string) => {
    return emailReg.test(email);
};

/**
 * @description 只能是数字和英文
 */
export const neReg = /^[A-Za-z0-9]+$/;
export const isNE = (value: string) => {
    return neReg.test(value);
};

/**
 * @description 是否是pwa
 */
export const isInStandaloneMode = () =>
    window.matchMedia("(display-mode: standalone)").matches ||
    document.referrer.includes("android-app://");

export const formatAmount = (amount?: string | number, fixed = 2) => {
    let toAmount: number | string = 0;
    if (!!amount) {
        toAmount = amount;
    }
    const base = new BigNumber(toAmount).toFormat(fixed);
    let [integerPart, fractionalPart] = base.split(".");
    integerPart = integerPart.replace(/\,/gi, ".");
    return `${integerPart},${fractionalPart}`;
};
export const goBlankPage = async (handler: Function | string, target = "_self") => {
    const isFunHanlder = typeof handler === "function";
    let newTab: any = null;
    const isSafariMobileBrowser =
        /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);

    if (isFunHanlder && target === "_blank" && isSafariMobileBrowser) {
        newTab = window.open("", "_blank"); //window.open("about:blank");
    }
    let href = "";
    try {
        href = isFunHanlder ? await handler() : handler;
    } catch (e) {
        if (newTab) newTab.close();
        throw new Error(e as string);
    }

    if (!href) {
        if (newTab) newTab.close();
        return;
    }

    if (newTab && isSafariMobileBrowser) {
        newTab.location.href = href;
    } else {
        const a = document.createElement("a");
        a.target = target;
        a.href = href;
        document.body.append(a);
        setTimeout(() => {
            a.href = href;
            a.click();
        }, 300);
    }
};

export const commonMask = {
    count: 0,
    timer: null as any,
    show() {
        if (this.count <= 0) {
            this.count === 0;
        }
        if (this.count > 0) {
            this.count++;
            return;
        }
        this.count++;
        if (typeof window === "undefined") return;
        var dom: HTMLDivElement | null = document?.querySelector("#globalMask");
        if (dom) {
            dom.style.display = "flex";
        }
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
        this.timer = setTimeout(() => {
            if (this.count > 0) {
                this.count = 0;
                this.hide();
            }
        }, 10 * 1000);
    },
    hide() {
        if (this.count > 0) {
            this.count--;
        }
        if (this.count >= 1) {
            return;
        }
        if (typeof window === "undefined") return;
        var dom: HTMLDivElement | null = document?.querySelector("#globalMask");
        if (dom) {
            dom.style.display = "none";
        }
    },
};
export const inputNumber = (
    value: string,
    opts?: {
        max?: number;
        length?: number;
        notNumber?: boolean;
        fixed?: number;
    }
) => {
    const toValue = value.replace(/[^0-9]/gi, "");
    let toAmount = "";
    let toFixedNum = opts?.fixed ? opts?.fixed : 0;
    if (toValue && !opts?.notNumber) {
        toAmount = new BigNumber(toValue).toFixed(toFixedNum, BigNumber.ROUND_DOWN);
        if (opts?.max !== undefined && new BigNumber(toAmount).isGreaterThan(opts.max)) {
            toAmount = new BigNumber(opts.max).toFixed(toFixedNum, BigNumber.ROUND_DOWN);
        }
    }
    if (toValue && opts?.notNumber) {
        toAmount = toValue;
    }

    if (opts?.length && toAmount.length > opts.length) {
        toAmount = toAmount.slice(0, opts.length);
    }

    return toAmount;
};
export const isPWAorAPK = (): boolean => {
    const displayModes = ["fullscreen", "standalone", "minimal-ui"];
    const matchesPwa = displayModes.some(
        (displayMode) => window.matchMedia("(display-mode: " + displayMode + ")").matches
    );
    return (
        matchesPwa ||
        (window.navigator as any)?.standalone ||
        document.referrer.includes("android-app://") ||
        window?.isAndroidAPK
    );
};
export const getDayEnd = () => {
    return dayjs().endOf("day").unix();
};
export const getWeekEnd = () => {
    return dayjs().endOf("week").add(1, "day").unix();
};
export const getMonthEnd = () => {
    return dayjs().endOf("month").unix();
};
export const sleep = (wait: number = 1000) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(true);
        }, wait);
    });
};
